import ETextInput from '@/components/everridge/ETextInput';
import InformationIconSolid from '@/components/icons/InformationIconSolid';
import { FC } from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SettingsFormData } from '@/features/settings/SettingsPage';
import EPhoneNumberInput from '@/components/everridge/EPhoneNumberInput';
import { cn } from '@/lib/utils';

type Props = {
	control: Control<SettingsFormData>;
	isMobile?: boolean;
};

const SettingsCompanyDetails: FC<Props> = ({ control, isMobile }) => {
	const { t } = useTranslation();

	return (
		<div
			className={cn(
				'w-1/2 p-6 flex flex-col gap-4 border border-popover-100 rounded-2.5xl bg-popover-10',
				isMobile && 'w-full p-0 border-0 bg-popover-30',
			)}>
			<h3 className={cn(isMobile && 'text-base')}>
				{t('main.settings.components.company.title')}
			</h3>
			<div className='flex gap-2 flex-wrap'>
				<ETextInput
					control={control}
					fieldName={'companyName'}
					label={t('elements.form.company.label')}
					placeholder={t('elements.form.company.placeholder')}
				/>
				<ETextInput
					control={control}
					fieldName={'companyTin'}
					label={t('elements.form.tin.label')}
					placeholder={t('elements.form.tin.placeholder')}
				/>
			</div>
			<ETextInput
				control={control}
				fieldName={'legalAddress'}
				label={t('elements.form.legalAddress.label')}
				placeholder={t('elements.form.legalAddress.placeholder')}
			/>
			<div className='flex gap-2 flex-wrap'>
				<EPhoneNumberInput
					control={control}
					fieldName={'phoneNumber'}
					label={t('elements.form.phone.label')}
					numberPlaceholder={t('elements.form.phone.placeholder')}
					iddPlaceholder={t('elements.form.phoneIDD.placeholder')}
				/>
				<ETextInput
					control={control}
					fieldName={'website'}
					label={t('elements.form.website.label')}
					placeholder={t('elements.form.website.placeholder')}
				/>
			</div>
			<div className='p-3.5 flex gap-2 border border-popover-100 rounded-semi-xl bg-popover-10'>
				<InformationIconSolid className='size-4 shrink-0' />
				<p className='text-xs font-medium text-popover-800'>
					{t('main.settings.components.company.text')}
				</p>
			</div>
		</div>
	);
};

export default SettingsCompanyDetails;
